import constant from "../main.constants";

const faceRoutes = [
    {
        path: "/face/manual-upload",
        name: "FaceManualUpload",
        component: () => import("../views/face/FaceManualUpload.vue"),
        meta: {
            icon: "mdi-cloud-upload-outline",
            localize: "face.routes.manualUpload",
            roles: [constant.PERMISSIONS && constant.PERMISSIONS.faceManualUpload || "faceManualUpload"]
        },
        perm: "faceManualUpload"
    },
    {
        path: "/face/batch-search",
        name: "FaceBatchSearch",
        component: () => import("../views/face/FaceBatchSearch.vue"),
        meta: {
            icon: "mdi-image-multiple-outline",
            localize: "face.routes.batchSearch"
        },
        perm: "faceBatchSearch"
    },
    {
        path: "/face/jobs",
        name: "FaceJobs",
        component: () => import("../views/face/FaceJobs.vue"),
        meta: {
            icon: "mdi-clipboard-list-outline",
            localize: "face.routes.jobs"
        },
        perm: "faceJobs"
    },
    {
        path: "/face/jobs/:jobId",
        name: "FaceJobDetail",
        component: () => import("../views/face/FaceJobs.vue"),
        meta: {
            icon: "mdi-clipboard-list-outline",
            localize: "face.routes.jobs"
        },
        perm: "faceJobs",
        props: true
    },
    {
        path: "/face/video",
        name: "FaceVideoUpload",
        component: () => import("../views/face/FaceVideoUpload.vue"),
        meta: {
            icon: "mdi-video-outline",
            localize: "face.routes.video"
        },
        perm: "faceVideo"
    },
    {
        path: "/face/video/:uploadId",
        name: "FaceVideoUploadDetail",
        component: () => import("../views/face/FaceVideoUpload.vue"),
        meta: {
            icon: "mdi-video-outline",
            localize: "face.routes.video"
        },
        perm: "faceVideo",
        props: true
    },
    {
        path: "/face/scenarios",
        name: "FaceScenarios",
        component: () => import("../views/face/FaceScenarios.vue"),
        meta: { icon: "mdi-cog-sync-outline", localize: "face.routes.scenarios" },
        perm: "faceScenario"
    },
    {
        path: "/face/alarms",
        name: "FaceAlarms",
        component: () => import("../views/face/FaceAlarms.vue"),
        meta: { icon: "mdi-bell-alert-outline", localize: "face.routes.alarms" },
        perm: "faceAlarm"
    },
    {
        path: "/face/system-config",
        name: "FaceSystemConfig",
        component: () => import("../views/face/FaceSystemConfig.vue"),
        meta: { icon: "mdi-tune-vertical", localize: "face.routes.systemConfig" },
        perm: "faceAdmin"
    },
    {
        path: "/face/exclusions",
        name: "FaceExclusionList",
        component: () => import("../views/face/FaceExclusionList.vue"),
        meta: { icon: "mdi-cancel", localize: "face.routes.exclusions" },
        perm: "faceAdmin"
    },
    {
        path: "/face/co-presence",
        name: "FaceCoPresence",
        component: () => import("../views/face/FaceCoPresence.vue"),
        meta: { icon: "mdi-account-network-outline", localize: "face.routes.coPresence" },
        perm: "faceCoPresence"
    },
    {
        path: "/face/person/:kimlikno",
        name: "FacePersonDetail",
        component: () => import("../views/face/FacePersonDetail.vue"),
        meta: { icon: "mdi-account-box-outline", localize: "face.routes.personDetail" },
        perm: "facePerson",
        props: true
    }
];

export default faceRoutes;
